import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { PriorityBadge, StatusPill } from "../../components/Pills";

export default function SessionHistory() {
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    api.get("/sessions?scope=mine").then(({ data }) => setSessions(data));
  }, []);

  return (
    <div className="p-6 lg:p-8">
      <div className="mb-6">
        <div className="bin-label">LEDGER</div>
        <h1 className="text-3xl font-black tracking-tighter mt-1">Session History</h1>
      </div>

      <div className="bin-card overflow-hidden">
        <table className="w-full text-xs font-mono">
          <thead className="bg-[#18181b]">
            <tr className="text-left text-zinc-500">
              <th className="px-4 py-3">When</th>
              <th>Station</th>
              <th>Device</th>
              <th>Priority</th>
              <th>Status</th>
              <th className="text-right">kWh</th>
              <th className="text-right">Cost</th>
            </tr>
          </thead>
          <tbody>
            {sessions.map((s) => (
              <tr key={s.id} className="border-t border-zinc-800 hover:bg-white/2">
                <td className="px-4 py-3 text-zinc-400">{new Date(s.start_time).toLocaleString()}</td>
                <td>{s.station_name}</td>
                <td>{s.device_name}</td>
                <td><PriorityBadge priority={s.priority} /></td>
                <td><StatusPill status={s.status} /></td>
                <td className="text-right">{s.energy_kwh.toFixed(3)}</td>
                <td className="text-right text-cyan-400 px-4">${s.cost_usd.toFixed(3)}</td>
              </tr>
            ))}
            {sessions.length === 0 && (
              <tr><td className="p-6 text-center text-zinc-500" colSpan="7">No sessions yet</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
